<template>
  <div class="comming-group">
    <p class="comming-head">Comming soon</p>
    <p class="need-help">Need help? Feel free to contact our team at b2bsupport@elsanow.io</p>
    <a href="https://speechanalyzer.elsaspeak.com/" target="blank">Back to Speech Analyzer</a>
  </div>
</template>

<script>
  export default {
        
  }
</script>
<style lang="scss" scoped>
.comming-group {
  margin: auto;
  text-align: center;
  margin-top: 250px;
  margin-bottom: 300px;
  .comming-head {
    font-size: 40px;
    font-weight: bold;
    margin: 0 20px;
  }
  .need-help {
    max-width: 350px;
    font-size: 18px;
    line-height: 26px;
  }
  a {
    font-size: 18px;
  }
}
</style>
